export default __webpack_public_path__ + "static/media/messenger-icon.d5052aa4.svg";